import TextareaSection from "../TextareaSection";
import descriptionIcon from "../../../assets/icons/description.webp";
import messageIcon from "../../../assets/icons/message.webp";
import { StyledSeparatorLine } from "./index.styled";
import { useSelector } from "react-redux";
import type { RootState } from "../../../store";

interface TextareaSectionsProps {
  statusDescription: string;
  replyMessage: string;
  onStatusDescriptionChange: (value: string) => void;
  onReplyMessageChange: (value: string) => void;
}

const TextareaSections: React.FC<TextareaSectionsProps> = ({
  statusDescription,
  replyMessage,
  onStatusDescriptionChange,
  onReplyMessageChange,
}) => {
  const { status } = useSelector((state: RootState) => state.dashboard);
  const contactName = status?.contact_name || "טוויסט";

  const defaultReplyMessage = `נשמרת בהצלחה אצל ${contactName}
על מנת לצפות בסטטוסים יש לשמור את איש הקשר של ${contactName}
👇👇👇`;

  const displayReplyMessage = replyMessage || defaultReplyMessage;
  const replyPlaceholder = replyMessage
    ? "כאן מקלידים טקסט כלשהו"
    : defaultReplyMessage;

  return (
    <>
      <TextareaSection
        title="תיאור הסטטוס"
        icon={descriptionIcon}
        placeholder="כאן מקלידים טקסט כלשהו"
        value={statusDescription}
        onChange={onStatusDescriptionChange}
        iconSize={18}
      />
      <TextareaSection
        title="הודעת תגובה"
        icon={messageIcon}
        placeholder={replyPlaceholder}
        value={displayReplyMessage}
        onChange={onReplyMessageChange}
      />
      <StyledSeparatorLine />
    </>
  );
};

export default TextareaSections;
